import { getBuilders, getFiller } from '../utilities/types';

export default function buildBuilders(key, type) {
  const { build, ...builders } = getBuilders(type);
  const fill = getFiller(type);
  return {
    build,
    ...builders,
    fill,
  };
}
